import React, { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../services/AuthService";
import "./ResetPassword.css";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = useMemo(
    () => new URLSearchParams(location.search).get("token") || "",
    [location.search]
  );

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(token ? "" : "Şifre sıfırlama bağlantısı geçersiz veya eksik.");
  const [submitting, setSubmitting] = useState(false);

  const bgStyle = {
    backgroundImage: "var(--auth-bg-image, url('/geometric-bg.png'))",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: "var(--auth-bg-color, #ffffff)",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nextPassword = String(password || "");
    if (!token) {
      setError("Şifre sıfırlama bağlantısı geçersiz veya eksik.");
      setMessage("");
      return;
    }

    if (nextPassword.length < 6) {
      setError("Yeni şifreniz en az 6 karakter olmalıdır.");
      setMessage("");
      return;
    }

    if (nextPassword !== confirmPassword) {
      setError("Şifreler eşleşmiyor.");
      setMessage("");
      return;
    }

    setSubmitting(true);
    setError("");
    setMessage("");

    try {
      const res = await resetPassword(token, nextPassword);
      setMessage(res?.message || "Şifreniz başarıyla güncellendi.");
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(
        err?.message ||
          "Şifre güncellenemedi. Bağlantı süresi dolmuş olabilir."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="reset-password-wrapper">
      <div className="reset-password-media">
        <video src="/login_video.mp4" autoPlay loop muted playsInline />
        <img src="/buglog-white.svg" alt="Buglog" className="corner-logo" />
      </div>

      <div className="reset-password-section" style={bgStyle}>
        <form className="reset-password-card" onSubmit={handleSubmit}>
          <img src="/buglog.svg" alt="Buglog" className="reset-password-logo" />
          <div className="reset-password-copy">
            <h1>Yeni Şifre Belirle</h1>
            <p>Hesabınız için güvenli bir şifre oluşturun.</p>
          </div>

          <div className="reset-password-field">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Yeni şifre"
              autoComplete="new-password"
              disabled={!token || submitting}
            />
          </div>

          <div className="reset-password-field">
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Yeni şifre tekrar"
              autoComplete="new-password"
              disabled={!token || submitting}
            />
          </div>

          {error ? <p className="reset-password-feedback error">{error}</p> : null}
          {message ? <p className="reset-password-feedback success">{message}</p> : null}

          <button
            type="submit"
            className="reset-password-submit"
            disabled={!token || submitting}
          >
            {submitting ? "Güncelleniyor..." : "Şifreyi Güncelle"}
          </button>

          <button
            type="button"
            className="reset-password-login"
            onClick={() => navigate("/login")}
          >
            Giriş ekranına dön
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
